import api from "../../api/index";
import {
  CLICKED_MARKER_ON_MAP,
  POINTER_ON_MAP,
  FETCH_ALL_MARKERS_ON_MAP,
  MAP_ACTION_LOADING,
} from "../actionTypes";

const clickMarkerOnMap = (payload) => {
  return {
    type: CLICKED_MARKER_ON_MAP,
    payload,
  };
};

const pointerOnMap = (payload) => {
  return {
    type: POINTER_ON_MAP,
    payload,
  };
};

const fetchAllMarkersOnMap = () => async (dispatch) => {
  await api
    .get("/api/markers")
    .then((res) => {
      const { data } = res.data;
      dispatch({ type: FETCH_ALL_MARKERS_ON_MAP, payload: data });
    })
    .catch((err) => {
      console.log("err", err);
    });
};

const addNewMarkerOnMap = (payload) => async (dispatch) => {
  const request = (payload) => dispatch({ type: MAP_ACTION_LOADING, payload });

  dispatch(request(true));
  await api
    .post("/api/marker", payload)
    .then(async () => {
      await api
        .get("/api/markers")
        .then((res) => {
          dispatch(request(false));

          const { data } = res.data;
          dispatch({ type: FETCH_ALL_MARKERS_ON_MAP, payload: data });
        })
        .catch((err) => {
          dispatch(request(false));

          console.log("err", err);
        });
    })
    .catch((err) => {
      dispatch(request(false));
    });
};

const updateSelectedMarkerOnMap = (payload) => async (dispatch) => {
  await api.put(`/api/marker/${payload.uniqueId}`, payload);
};

const removeMarker = (id) => async (dispatch) => {
  const request = (payload) => dispatch({ type: MAP_ACTION_LOADING, payload });

  dispatch(request(true));
  await api
    .delete(`/api/marker/${id}`)
    .then(async () => {
      await api
        .get("/api/markers")
        .then((res) => {
          const { data } = res.data;
          dispatch(request(false));
          dispatch({ type: FETCH_ALL_MARKERS_ON_MAP, payload: data });
        })
        .catch((err) => {
          dispatch(request(false));

          console.log("err", err);
        });
    })
    .catch((err) => {
      dispatch(request(false));
    });
};

export const markerActions = {
  fetchAllMarkersOnMap,
  clickMarkerOnMap,
  addNewMarkerOnMap,
  removeMarker,
  updateSelectedMarkerOnMap,
  pointerOnMap,
};
